import { baseURL } from '@/api/base'

export default {
  printForm(specialityId) {
    let queryParams = `?specialityId=${specialityId}`

    return `${baseURL}/print/printForm${queryParams}`
  }
}
